import * as React from 'react';

import { withExceptionCatcher } from '@/components/hoc/with-exception-catcher';
import TagPageLayout from '@/components/pages/tag/layout/tag-page-layout';
import { ArticleType } from '@/types/article-type';
import { Tag } from '@/utils/functions/wordpress/fetch-tags';

export interface TagPageControllerProps {
    articles: ArticleType[];
    tag: Tag;
}

const TagPageController = ({ tag, articles }: TagPageControllerProps) => {
    return <TagPageLayout articles={articles} tag={tag} />;
};

export default withExceptionCatcher(TagPageController);
